import type { CdiSyncJob } from "@dashboardApi/apis/integrationsDirectCdiJobsJobId";
import type { BaseTableParams } from "@dashboardApi/apis/types";
import type { BaseTableResultItem, TableResult } from "@tanstack/react-table";

export interface IntegrationsDirectCdiJobsParams extends BaseTableParams {
  /** the query object containing all the filters */
  query?: Partial<Record<string, string | string[]>>;
}

export const jobSyncStatusValues = <const>[
  "config_error",
  "partial",
  "running",
  "error",
  "success",
  "limit_exceeded",
];

export const originalJobSyncStatusValues = <const>[
  "started",
  "syncing",
  "synced",
  "ingesting",
  "ingested",
  "complete",
  "error",
  "sync_error",
  "ingest_error",
  "source_error",
  "sink_error",
  "running",
  "config_error",
  "limit_exceeded",
];

export type JobSyncStatus = (typeof jobSyncStatusValues)[number];

export type OriginalJobSyncStatus = (typeof originalJobSyncStatusValues)[number];

export interface CdiJobsResultsItem extends CdiSyncJob, BaseTableResultItem {}

export type CdiJobsResults = TableResult<CdiJobsResultsItem>;
